import {App} from 'vue';
import {Store} from 'vuex';
import {create, ModalInterface} from '@/api/modal';
import ModalConfirm from "@/modal/ModalConfirm.vue";
import ModalMessage from "@/modal/ModalMessage.vue";

export interface Options {
    store: Store<any>
}

export default {
    install(app: App, options: Options) {

        const modal: ModalInterface = create({
            app,
            store: options.store,
            components: {
                confirm: ModalConfirm,
                message: ModalMessage,
            }
        })

        app.provide('$modal', modal);
        app.config.globalProperties.$modal = modal;
    }
}